    <section class="basic-information-section">
        <h3>{{"dashboard:Basic Information" | i18next}}</h3>
        <div class="section-content basic-information thin-scroll">
            <div>
                <div>
                    <span>{{'dashboard:Report Name' | i18next}}</span>
                    <div>
                        <app-widget-textbox [model]="report?.shortDescription" [disabled]="true" textboxWidth="100%"></app-widget-textbox>
                    </div>
                </div>
                <ng-container *ngIf="report.subReportId > 0">
                    <div>
                        <span>{{ 'dashboard:Category' | i18next }}</span>
                        <div>
                            <ng-select [items]="reportCategories" bindLabel="category" bindValue="id" [(ngModel)]="report.categoryId" class="category-select"
                                       placeholder="{{ 'Select'| i18next }}" [class.active]="categoriesOpened" (focus)="categoriesOpened=true" (blur)="categoriesOpened=false"
                                       [searchable]="false" [disabled]="true">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"  dropdownPosition="bottom">
                                    <div class="ng-option-template">
                                        {{item.category}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div>
                        <span> {{ 'dashboard:Based on' | i18next }}</span>
                        <div>
                            <app-widget-textbox [model]="report?.standReportName" [disabled]="true" textboxWidth="100%"></app-widget-textbox>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="!basicExpanded || report.subReportId>0">
                    <span>{{ (report.subReportId > 0 ? 'dashboard:Custom Description':"dashboard:Description") | i18next }}</span>
                    <app-widget-textbox [model]="report.subReportId>0? report.userDescription:report.longDescription" textboxWidth="100%" [disabled]="true" class="short-description-widget-textbox"></app-widget-textbox>
                </div>
                <div>
                    <span class="settings-sub-title empty"></span>
                    <div>
                        <button mat-flat-button class='secondary-button' (click)="basicExpanded=!basicExpanded">
                            <ng-container *ngIf="basicExpanded">{{ 'dashboard:Hide Details' | i18next }}</ng-container>
                            <ng-container *ngIf="!basicExpanded">{{ 'dashboard:Show Details' | i18next }}</ng-container>
                        </button>
                    </div>
                </div>
            </div>

            <div class="long-description thin-scroll" [@collapse]="!basicExpanded">
                <h4>{{ 'dashboard:Description' | i18next }}</h4>
                <pre>{{report.longDescription}}</pre>
                <div class="filter-container">
                    <mat-radio-group class="report-type-radio-group" [(ngModel)]="infoAllColumns" (ngModelChange)="getColumnsFiltered()">
                        <mat-radio-button [value]="false" class="redRadio"> <span class="radio-lable">{{ 'dashboard:Active columns' | i18next }}</span></mat-radio-button>
                        <mat-radio-button [value]="true" class="redRadio"> <span class="radio-lable">{{ 'dashboard:All columns' | i18next }}</span></mat-radio-button>
                    </mat-radio-group>

                   <span>{{ 'dashboard:Filter' | i18next }} </span>
                     <app-widget-textbox class="filter-box" [model]="filterTableInput" (modelChange)="filterTableInput=$event;getColumnsFiltered()"
        placeholder="{{ 'dashboard:Filter table' | i18next }}..." textboxWidth="300px"></app-widget-textbox>
    <i class="fal fa-search"></i>


                </div>
                <div class="basic-info-columns">
                    <div class="odd">
                        <div>{{ 'dashboard:Colomn' | i18next}}</div>
                        <div>{{ 'dashboard:Description' | i18next }}</div>
                    </div>
                    <div *ngFor="let column of filteredTable;index as i" [class.odd]="i % 2">
                        <div [innerHTML]="column.shortDescription"></div>
                        <div [innerHTML]="column.longDescription"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-content-expand">
            <div (click)="basicExpanded=!basicExpanded">
                <i class="far fa-chevron-down" [class.fa-chevron-up]="basicExpanded"></i>
            </div>
        </div>
    </section>
